export default class PageModule {}